(() => {
  const destinations = { privacy: '/policies/privacy-policy', terms: '/policies/terms-of-service' };
  function repairLinks(root) {
    const links = [];
    if (root.nodeType === 1 && root.matches('a')) links.push(root);
    if (root.querySelectorAll) links.push(...root.querySelectorAll('a'));
    for (const link of links) {
      let path;
      try { path = decodeURIComponent(new URL(link.getAttribute('href') || '', location.origin).pathname); } catch { continue; }
      if (path !== '/[link]' && path !== '[link]') continue;
      const label = (link.textContent || link.getAttribute('aria-label') || '').toLowerCase();
      if (label.includes('privacy')) link.setAttribute('href', destinations.privacy);
      else if (label.includes('terms')) link.setAttribute('href', destinations.terms);
    }
  }
  repairLinks(document);
  new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) {
      if (node.nodeType === 1) repairLinks(node);
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
